import React from 'react'
// FR, EN
const NotFoundPage: React.FC<{ locale: string }> = ({ locale = 'en' }: { locale?: string }) => {
  return (
    <div className="not-found-container">
      <div className="not-found-logo">
        <img src="/logo.png" alt="Vocads Logo" className='not-found-logo-img' />
      </div>
      <div className="not-found-title">
        {locale === 'fr' ? 'Rien à voir ici!' : 'Nothing to see here!'}
      </div>
      <div className="not-found-subtitle">
        {locale === 'fr'
          ? 'Vérifiez votre lien ou contactez votre administrateur de Vocads.'
          : 'Check your link or contact your Vocads administrator.'}
      </div>
    </div>
  )
}

export default NotFoundPage
